import { render, staticRenderFns } from "./OrdersCalendarOrderResumeServices.vue?vue&type=template&id=f27061ba&scoped=true&"
import script from "./OrdersCalendarOrderResumeServices.vue?vue&type=script&lang=js&"
export * from "./OrdersCalendarOrderResumeServices.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCalendarOrderResumeServices.vue?vue&type=style&index=0&id=f27061ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27061ba",
  null
  
)

export default component.exports